var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartLargeCircleClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1054,
    height: 1050,
    viewBox: "0 0 1054 1050",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1050 521C1050 808.74 816.74 1042 529 1042C241.26 1042 8 808.74 8 521C8 233.26 241.26 0 529 0C816.74 0 1050 233.26 1050 521ZM78.1743 521C78.1743 769.984 280.016 971.826 529 971.826C777.984 971.826 979.826 769.984 979.826 521C979.826 272.016 777.984 70.1743 529 70.1743C280.016 70.1743 78.1743 272.016 78.1743 521Z",
    fill: "url(#paint0_radial_4_6336)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_6336)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 527,
    cy: 521,
    rx: 523,
    ry: 521,
    fill: "url(#paint1_radial_4_6336)",
    fillOpacity: 0.07,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_6336",
    x: 0,
    y: 0,
    width: 1054,
    height: 1050,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_6336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_6336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4_6336",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(529 521) rotate(90) scale(521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#0F0F0F",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4_6336",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(527 521) rotate(90) scale(521 523)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17408,
    stopColor: "#16103E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238659,
    stopColor: "#0F0838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62953,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#140C43",
    stopOpacity: 0.77
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLargeCircleClosed);
export default __webpack_public_path__ + "static/media/chart-large-circle-closed.0c358387080c4079ceda697297abce21.svg";
export { ForwardRef as ReactComponent };